<template>
  <nav class="gym-nav" :class="{ 'gym-nav--scrolled': scrolled }">
    <div class="gym-nav-inner">

      <router-link class="gym-nav-logo" to="/products/cloudtec-gym">
        <img class="gym-logo-img" src="@/assets/CTGYM.YELLOW 1080x1080.svg" alt="Cloudtec Gym logo" />
        <span class="gym-logo-text">Cloudtec <strong>Gym</strong></span>
      </router-link>

      <nav class="gym-nav-links" aria-label="Κύρια πλοήγηση">
        <router-link :to="{ path: '/products/cloudtec-gym', hash: '#features' }">Χαρακτηριστικά</router-link>
        <router-link to="/products/cloudtec-gym/how-it-works">Πώς Λειτουργεί</router-link>
        <router-link to="/products/cloudtec-gym/docs">Τεκμηρίωση</router-link>
      </nav>

      <div class="gym-nav-actions">
        <a class="gym-nav-appstore" href="https://play.google.com/store/apps/details?id=com.nvourlidas.ctgym"
           target="_blank" rel="noopener">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
          </svg>
          Google Play
        </a>
        <a class="gym-nav-appstore" href="https://apps.apple.com/gr/app/cloudtec-gym/id6757802948"
           target="_blank" rel="noopener">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
          App Store
        </a>
        <a class="gym-nav-demo" href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener">Ξεκινήστε Δωρεάν</a>
      </div>

      <button class="gym-nav-burger" @click="open = !open"
              :class="{ open }" :aria-label="open ? 'Κλείσιμο μενού' : 'Άνοιγμα μενού'" :aria-expanded="open">
        <span></span><span></span><span></span>
      </button>
    </div>

    <!-- Mobile menu -->
    <div class="gym-nav-mobile" :class="{ open }">
      <router-link :to="{ path: '/products/cloudtec-gym', hash: '#features' }" @click="open = false">Χαρακτηριστικά</router-link>
      <router-link to="/products/cloudtec-gym/how-it-works" @click="open = false">Πώς Λειτουργεί</router-link>
      <router-link to="/products/cloudtec-gym/docs" @click="open = false">Τεκμηρίωση</router-link>
      <router-link :to="{ path: '/products/cloudtec-gym', hash: '#pricing' }" @click="open = false">Πλάνα & Τιμές</router-link>
      <router-link :to="{ path: '/products/cloudtec-gym', hash: '#faq' }" @click="open = false">FAQ</router-link>
      <div class="gym-nav-mobile-cta">
        <a href="https://play.google.com/store/apps/details?id=com.nvourlidas.ctgym" target="_blank" rel="noopener">Google Play</a>
        <a href="https://apps.apple.com/gr/app/cloudtec-gym/id6757802948" target="_blank" rel="noopener">App Store</a>
        <a href="https://ctgym.cloudtec.gr" target="_blank" rel="noopener" @click="open = false">Ξεκινήστε Δωρεάν</a>
      </div>
    </div>

    <!-- Scroll progress bar -->
    <div class="gym-nav-progress" :style="{ transform: `scaleX(${progress / 100})` }"></div>
  </nav>
</template>

<script>
export default {
  name: 'GymNavBar',

  data() {
    return {
      scrolled: false,
      progress: 0,
      open: false,
    };
  },

  mounted() {
    this._onScroll = () => {
      const scrollY = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      this.scrolled = scrollY > 20;
      this.progress = maxScroll > 0 ? (scrollY / maxScroll) * 100 : 0;
    };
    window.addEventListener('scroll', this._onScroll, { passive: true });
  },

  beforeUnmount() {
    if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
  },
};
</script>

<style scoped>
.gym-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(25, 36, 50, 0.88);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s, background 0.2s;
}

.gym-nav--scrolled {
  background: rgba(25, 36, 50, 0.97);
  border-bottom-color: rgba(255,255,255,0.07);
}

.gym-nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 60px;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.gym-nav-logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  text-decoration: none;
  color: #fff;
  font-size: 1rem;
  flex-shrink: 0;
}

.gym-logo-img { width: 36px; height: 36px; object-fit: contain; }
.gym-logo-text { font-size: 0.95rem; }
.gym-logo-text strong { color: #FFC947; }

.gym-nav-links {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex: 1;
  justify-content: center;
}

.gym-nav-links a {
  text-decoration: none;
  color: rgba(255,255,255,0.72);
  font-size: 0.88rem;
  font-weight: 600;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  transition: color 0.15s, background 0.15s;
}

.gym-nav-links a:hover,
.gym-nav-links a.router-link-active,
.gym-nav-links a.router-link-exact-active {
  color: #fff;
  background: rgba(255,255,255,0.08);
}

.gym-nav-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-shrink: 0;
}

.gym-nav-appstore {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  color: rgba(255,255,255,0.8);
  font-size: 0.82rem;
  font-weight: 700;
  border: 1px solid rgba(255,255,255,0.14);
  border-radius: 999px;
  padding: 0.4rem 0.9rem;
  transition: background 0.15s, color 0.15s;
}

.gym-nav-appstore:hover { background: rgba(255,255,255,0.1); color: #fff; }

.gym-nav-demo {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: #1a2535;
  font-size: 0.82rem;
  font-weight: 800;
  background: #FFC947;
  border-radius: 999px;
  padding: 0.4rem 1rem;
  transition: opacity 0.15s, transform 0.15s;
}

.gym-nav-demo:hover { opacity: 0.88; transform: translateY(-1px); }

.gym-nav-burger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px;
  cursor: pointer;
  padding: 0 9px;
  flex-shrink: 0;
  transition: background 0.15s;
}

.gym-nav-burger:hover { background: rgba(255,255,255,0.1); }

.gym-nav-burger span {
  display: block;
  height: 2px;
  width: 100%;
  background: rgba(255,255,255,0.8);
  border-radius: 2px;
  transition: transform 0.22s, opacity 0.22s;
  transform-origin: center;
}

.gym-nav-burger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.gym-nav-burger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
.gym-nav-burger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

.gym-nav-mobile {
  display: none;
  flex-direction: column;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0 1.5rem;
  border-top: 1px solid transparent;
}

.gym-nav-mobile.open {
  max-height: 560px;
  padding: 1rem 1.5rem;
  border-top-color: rgba(255,255,255,0.07);
}

.gym-nav-mobile a {
  display: block;
  text-decoration: none;
  color: rgba(255,255,255,0.75);
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.7rem 0;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  transition: color 0.15s;
}

.gym-nav-mobile a:last-of-type { border-bottom: none; }
.gym-nav-mobile a:hover { color: #FFC947; }

.gym-nav-mobile-cta {
  display: flex;
  gap: 0.7rem;
  padding-top: 0.9rem;
  flex-wrap: wrap;
}

.gym-nav-mobile-cta a {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 800;
  border-radius: 999px;
  padding: 0.5rem 1.1rem;
  border-bottom: none !important;
}

.gym-nav-mobile-cta a:not(:last-child) {
  border: 1px solid rgba(255,255,255,0.15);
  color: rgba(255,255,255,0.85);
  background: transparent;
}

.gym-nav-mobile-cta a:last-child { background: #FFC947; color: #1a2535; }

.gym-nav-progress {
  position: absolute;
  bottom: 0; left: 0;
  width: 100%;
  height: 2px;
  background: #FFC947;
  transform-origin: left;
  transform: scaleX(0);
  transition: transform 0.1s linear;
}

@media (max-width: 768px) {
  .gym-nav-links   { display: none; }
  .gym-nav-actions { display: none; }
  .gym-nav-burger  { display: flex; }
  .gym-nav-mobile  { display: flex; }
  .gym-nav-inner   { justify-content: space-between; }
}
</style>
